import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { RadioQuestion } from '../../../classes/question-radio';

@Component({
  selector: 'bepatient-input-radio',
  templateUrl: './input-radio.component.html',
  styleUrls: ['./input-radio.component.scss'],
  standalone: false
})
export class InputRadioComponent {
  @Input() question: RadioQuestion;
  @Input() parent: UntypedFormGroup;
}
